export const NAV = {
  brand: "nav-brand",
  links: {
    home: "nav-link-home",
    about: "nav-link-about",
    competenze: "nav-link-competenze",
    progetti: "nav-link-progetti",
    libro: "nav-link-libro",
    contatti: "nav-link-contatti",
  },
  menuToggle: "nav-menu-toggle",
  cta: "nav-cta-contact",
};

export const HOME = {
  hero: "home-hero",
  manifesto: "home-manifesto",
  projectsSection: "home-projects",
  projectCard: (slug) => `home-project-${slug}`,
  ctaContact: "home-cta-contact",
};

export const PROJECTS = {
  list: "projects-list",
  card: (slug) => `project-card-${slug}`,
  filterAll: "projects-filter-all",
  filterContext: (ctx) => `projects-filter-${ctx}`,
};

export const PROJECT_DETAIL = {
  page: "project-detail",
  backLink: "project-back",
  metric: (i) => `project-metric-${i}`,
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  company: "contact-company",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabProjects: "admin-tab-projects",
  tabContacts: "admin-tab-contacts",
  newProject: "admin-new-project",
  saveProject: "admin-save-project",
  deleteProject: (id) => `admin-delete-project-${id}`,
  editProject: (id) => `admin-edit-project-${id}`,
};
